import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { playerDisplayName } from "./PlayerDisplayNameLink";
export const PlayerAvatar = ({ player, pictureUrl, name, playerId, size = 56, }) => {
    const displayName = player ? playerDisplayName(player) : name ?? "";
    const picture = player ? player.user?.picture : pictureUrl;
    const id = player ? player.id : playerId;
    const tooltip = (_jsx(Tooltip, { title: displayName, arrow: true, children: _jsx(Avatar, { src: picture ?? undefined, alt: displayName, sx: { width: size, height: size }, children: displayName.match(/\b(\w)/g)?.join("") }) }));
    if (id === undefined) {
        return tooltip;
    }
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/players/${id}/`, children: tooltip }, id));
};
